// action - state management
import { InitialLoginContextProps } from 'types/components/security';
import { LOGIN, LOGOUT, REGISTER, CODE_VERIFIED } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
    type: string;
    payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload!;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null
            };
        }
        case CODE_VERIFIED: {
            const { codeVerified } = action.payload!;
            return {
                ...state,
                codeVerified
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
